import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import {
  QueryParamTabs,
  type TabItem,
} from "Components/Shared/Tabs/QueryParamTabs";
import { CustomerParty } from "Components/UserAccount/Customer/CustomerParty/CustomerParty";
import { UserSettingsSection } from "Components/UserAccount/Shared/UserSettings/UserSettingsSection";
import type { AccountDetailProps as Props } from "Components/UserAccount/types";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Account;

// The Employee context serves the employee's own person (never the employer's company), so the
// profile shows that person. KYC declarations belong to the Customer context and stay out.
export const EmployeeUserAccountDetail = ({ party }: Props) => {
  const { t } = useResource();

  const tabs: Array<TabItem> = [
    {
      id: "party",
      label: t(COMPONENT_RESOURCES.PersonalInformation),
      content: (
        <PrimaryPaper>
          <CustomerParty party={party} />
        </PrimaryPaper>
      ),
    },
    {
      id: "account",
      label: t(COMPONENT_RESOURCES.AccountTab),
      content: (
        <PrimaryPaper>
          <UserSettingsSection />
        </PrimaryPaper>
      ),
    },
  ];

  return <QueryParamTabs tabs={tabs} />;
};
